import { render, staticRenderFns } from "./InvoiceViewSidebar.vue?vue&type=template&id=ef8214e6&"
import script from "./InvoiceViewSidebar.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports